import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import intersection from 'lodash/intersection';
import classnames from 'classnames';

import CollapseIcon from './collapse_icon';
import SearchFilterCheckbox from './SearchFilterCheckbox';
import { defaultFilter } from '../../reducers/courses';

const GroupHeader = styled.button`
  user-select: none;
  -webkit-appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
`;

class SubjectGroup extends Component {
  state = {
    collapsed: true,
  };

  componentDidMount() {
    this.checkForSelectedSubjects();
  }

  checkForSelectedSubjects = () => {
    const selected = this.selected();
    if (selected) {
      this.setState({ collapsed: false });
    }
  };

  selected = () => {
    const { group, filter } = this.props;
    return intersection(filter.s, group.subjectIds).length > 0;
  };

  toggleList = () => this.setState(({ collapsed }) => ({ collapsed: !collapsed }));

  render() {
    const {
      text,
      group,
      subjects,
      filter,
    } = this.props;

    const { collapsed } = this.state;
    const selected = this.selected();
    const filterTopics = !!(text && text.length);

    return (
      <div>
        <GroupHeader
          className={classnames('link-collapse', 'mb-2', {
            'text-secondary': !selected,
            'text-primary': selected,
          })}
          type="button"
          onClick={this.toggleList}
        >
          <CollapseIcon collapsed={collapsed} selected={selected} />
          {' '}
          {group.name}
        </GroupHeader>

        {(filterTopics || !collapsed) && (
          <div className="pl-2 pt-2">
            {group.subjectIds.map((id) => {
              const subject = subjects.subjects.byId[id];
              const { name } = subject;

              if (filterTopics && (name.toLowerCase().indexOf(text.toLowerCase()) === -1)) {
                return null;
              }

              return (
                <SearchFilterCheckbox
                  label={name}
                  value={subject.id}
                  name="s"
                  filter={filter}
                  defaultFilter={defaultFilter}
                  key={subject.id}
                />
              );
            }).filter((el) => !!el)}
          </div>
        )}
      </div>
    );
  }
}

SubjectGroup.propTypes = {
  group: PropTypes.shape({ id: PropTypes.number }).isRequired,
  subjects: PropTypes.shape({}).isRequired,
  filter: PropTypes.shape({}).isRequired,
};

export default SubjectGroup;
